// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fb-0";
export var fileCarousel = "_fb-2";
export var removeFileButton = "_fb-1";